export const EVENT_NAME = {
  'conta-dependente-ativada': 'at_patient_acc_activated_deps_modal',
  'conta-dependente-dados-atualizados':
    'at_patient_updated_dependents_data_modal',
  escolha: 'at_patient_multiprofile_dependents_modal',
}
